var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
import Loading from '@doordash/component-loading';
import { DynamicValuesProvider } from '@doordash/component-dynamic-values';
import { dynamicValues } from '@doordash/lib-dynamic-values-core';
import { withOverrides, getOverridesFromQueryParams, OverrideTypes, } from '@doordash/util-dynamic-values';
import * as Sentry from '@sentry/react';
import * as React from 'react';
import { useBootstrapDataAndConfigureGlobalUserContext } from './hook';
import { DynamicValuesProviderTestId } from './testId';
// Please start all DV name with "ddfw" to make sourcegraph searching easier
export var DYNAMIC_VALUES_NAME = {
    ddfwDisableWorkPortalDashPass_1: 'ddfwDisableWorkPortalDashPass_1',
    ddfwDisableWorkPortalDashPass_2: 'ddfwDisableWorkPortalDashPass_2',
    ddfwPendoEnabled: 'ddfwPendoEnabled',
    ddfwSelfServeOnboarding: 'ddfwSelfServeOnboarding',
    ddfwDinovaRewardsEnabled: 'ddfwDinovaRewardsEnabled',
    ddfwSelfServeLead: 'ddfwSelfServeLead',
    ddfwSelfServeDP: 'ddfwSelfServeDP',
    ddfwSelfServeDpBilling: 'ddfwSelfServeDpBilling',
};
var dvDefaults = (_a = {},
    _a[DYNAMIC_VALUES_NAME.ddfwDisableWorkPortalDashPass_1] = false,
    _a[DYNAMIC_VALUES_NAME.ddfwDisableWorkPortalDashPass_2] = false,
    _a[DYNAMIC_VALUES_NAME.ddfwPendoEnabled] = false,
    _a[DYNAMIC_VALUES_NAME.ddfwSelfServeOnboarding] = false,
    _a[DYNAMIC_VALUES_NAME.ddfwDinovaRewardsEnabled] = false,
    _a[DYNAMIC_VALUES_NAME.ddfwSelfServeLead] = false,
    _a[DYNAMIC_VALUES_NAME.ddfwSelfServeDP] = false,
    _a[DYNAMIC_VALUES_NAME.ddfwSelfServeDpBilling] = false,
    _a);
var env = {
    serviceName: 'app-corp-consumer-portal',
};
export var PortalDynamicValuesProvider = function (_a) {
    var _b, _c;
    var children = _a.children;
    var _d = useBootstrapDataAndConfigureGlobalUserContext(), data = _d.data, loading = _d.loading;
    if (loading) {
        return (React.createElement("div", { "data-testid": DynamicValuesProviderTestId.LoadingSpinner },
            React.createElement(Loading, { size: Loading.Sizes.Medium, color: Loading.Colors.SystemGrey30 })));
    }
    var dynamicValuesObject = {};
    try {
        var stringifiedDynamicValues = Boolean((_b = data.workPortalBootstrap) === null || _b === void 0 ? void 0 : _b.dynamicValues)
            ? (_c = data.workPortalBootstrap) === null || _c === void 0 ? void 0 : _c.dynamicValues : '{}';
        dynamicValuesObject = JSON.parse(stringifiedDynamicValues);
    }
    catch (err) {
        // nothing yet
    }
    var handlers = {
        sendError: function (error) {
            Sentry.captureEvent(error);
            console.error(error);
        },
        trackExposure: function (trackingData) {
            // nothing yet
            return;
        },
        getOnlineConfiguration: function (serviceName, name, envPrefix) {
            return dynamicValuesObject[name];
        },
    };
    var dynamicValuesInterpreter = dynamicValues.initialize(dvDefaults, env, handlers);
    var queryParams = Object.entries(dvDefaults).reduce(function (result, _a) {
        var _b;
        var _c = __read(_a, 2), dynamicValueName = _c[0], defaultValue = _c[1];
        if (typeof defaultValue === 'boolean') {
            return __assign(__assign({}, result), (_b = {}, _b[dynamicValueName] = OverrideTypes.boolean, _b));
        }
        return __assign({}, result);
    }, {});
    var queryParamOverrides = getOverridesFromQueryParams(queryParams);
    var dynamicValuesInterpreterWithOverride = withOverrides(dynamicValuesInterpreter, queryParamOverrides);
    return (React.createElement(DynamicValuesProvider, { dynamicValues: dynamicValuesInterpreterWithOverride }, children));
};
